import { CustomBoxV2 } from "components";
import { PitchingIcon } from "pages/internal-dashboard/icons";

export function Pitching({ data, loading, percentages }: any) {
  return (
    <CustomBoxV2
      loading={loading}
      color="#2DD683"
      title="Pitching"
      userCount={data?.total || 0}
      boxData={{
        label: "Pitching",

        todayCount: data?.day || 0,
        weekCount: data?.week || 0,
        monthCount: data?.month || 0,
        yearCount: data?.year || 0,
        icon: PitchingIcon,
      }}
      percentages={percentages}
    />
  );
}
